import React from 'react';
import styled, { keyframes } from 'styled-components';
import { ReactComponent as LoaderIcon } from './loaderIcon.svg';

const animate = keyframes`
  0%{
    transform: rotate(0);
  }
  25%{
    transform:  rotate(90deg);
  }
	50%{
    transform:  rotate(180deg);
  }
	75%{
		transform:  rotate(270deg);
  }
  100%{
    transform: rotate(360deg);
  }
`;

export const Loader = styled(LoaderIcon)`
  animation: ${animate} 2s steps(1) infinite;
`;

const LoginLoader = (props: { style?: React.CSSProperties }) => {
  return (
    <div style={props.style}>
      <Loader />
    </div>
  );
};

export default LoginLoader;
